import AwesomeDebouncePromise from 'awesome-debounce-promise';
import ApiService from '../services/apiService';

export const generateOvertimeReport = ({
  dispatch,
  params,
  format,
  responseType,
  failureCallback,
  successCallback,
  callback
}) => {
  ApiService.request('get', `/overtime_reports/overtime_record_reports/generate_report${format || ''}`, {
    dispatch,
    params,
    responseType,
    successCallback,
    failureCallback,
    callback
  });
};

export const debounceGenerateOvertimeReport = AwesomeDebouncePromise(generateOvertimeReport, 300);
